// extracted by mini-css-extract-plugin
export default {"bg":"HeaderCard_bg__PNlGi"};